var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavTabsSwiper',{attrs:{"tabs-list":_vm.tabsOrderList,"is-loading":_vm.isLoadingOrderList,"mobile-in-select":"","show-count-in-select":""}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }